import Point from "slotworks/utils/geom/point";
import LinesComponent from 'slotworks/components/lines/lines-component';

export default class EmptyLinesComponent extends LinesComponent {

    constructor(lineDefinitions: Point[][]) {
        super(lineDefinitions);
    }

    public drawLines(lineDefinitions: Point[][]) {
        
    }

    public showBox(pos: Point) {
        
    }

    public hideBoxes() {
        
    }

    public showLine(index: number, show: boolean) {
        
    }

    public hideAllLines() {
        
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/lines/lines-component.ts